function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { T } from 'shared/helper/translate';
import useNavigate from '../../hooks/useNavigate';
import { saveCriteriaWizardSession, updateSessionStage } from '../../actions';
import { getPreviousStep } from '../../reducer';
import RubriqSetupOnboardingStep from './RubriqSetupOnboardingStep';
import RubriqSetupProgress from './RubriqSetupProgress';
import RubriqSetupConfirmationStep from './RubriqSetupConfirmationStep';
import RubriqSetupTextLimitStep from './RubriqSetupTextLimitStep';
import RubriqSetupGeneralStep from './RubriqSetupGeneralStep';
var RubriqSetupStep = function RubriqSetupStep() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie;
  var _curie$abstractWriter = curie.abstractWriter,
    session = _curie$abstractWriter.session,
    steps = _curie$abstractWriter.steps,
    currentStep = _curie$abstractWriter.currentStep,
    responses = _curie$abstractWriter.criteriaResponses,
    title = _curie$abstractWriter.title;
  var _useParams = useParams(),
    step = _useParams.step;
  var isOnboardingStep = step === 'onboarding';
  var isConfirmationStep = step === 'confirmation';
  var isTextLimitStep = step === 'text-limit';
  var stepConfig = steps[step];
  var isValidStep = isOnboardingStep || isConfirmationStep || isTextLimitStep || stepConfig;
  var canRenderStep = isValidStep && !!(isOnboardingStep || step === currentStep || responses[step]);
  var previousStep = getPreviousStep({
    curie: curie
  }, step);
  var onboardingDefaultValues = {
    title: title
  };
  var textLimitDefaultValues = {
    maxLength: '',
    units: {
      value: 'words'
    }
  };
  var stepDefaultValues = {
    response: ''
  };

  // set up three separate forms since the "onboarding" and "text-limit" step uses a different field structure
  var methodsOnboarding = useForm({
    defaultValues: onboardingDefaultValues
  });
  var methodsTextLimit = useForm({
    defaultValues: textLimitDefaultValues
  });
  var useCharacters = methodsTextLimit.watch('units').value === 'characters';
  var methodsStep = useForm({
    defaultValues: stepDefaultValues
  });
  var dispatch = useDispatch();
  var navigate = useNavigate();
  var handleSubmit = function handleSubmit(data) {
    setSubmitting(true);
    dispatch(saveCriteriaWizardSession(step, data)).then(function (result) {
      setSubmitting(false);
      var session = result.session,
        currentStep = result.currentStep;

      // navigate to whatever is the next step
      navigate("/rubriq/abstract-writer/".concat(session, "/criteria/").concat(currentStep));
    });
  };
  var startTemplate = function startTemplate() {
    setSubmitting(true);
    // TODO: nothing to do here for the prototype but later this will start the drafting session
    dispatch(updateSessionStage(session, 'template')).then(function () {
      navigate("/rubriq/abstract-writer/".concat(session, "/template"));
    });
  };

  // reset form values when step changes
  useEffect(function () {
    if (!canRenderStep || isConfirmationStep) {
      return;
    }
    if (isTextLimitStep) {
      if (responses[step]) {
        var _responses$step = responses[step],
          maxLength = _responses$step.maxLength,
          _useCharacters = _responses$step.useCharacters;
        methodsTextLimit.reset({
          maxLength: maxLength,
          units: {
            value: _useCharacters ? 'characters' : 'words'
          }
        });
      } else {
        methodsTextLimit.reset(textLimitDefaultValues);
      }
    } else {
      methodsStep.reset(responses[step] ? {
        response: responses[step]
      } : stepDefaultValues);
    }
  }, [step]);

  // save current step when step changes
  useEffect(function () {
    if (!canRenderStep || step === currentStep) {
      return;
    }
    dispatch(saveCriteriaWizardSession(step));
  }, [step]);
  if (!canRenderStep) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-4 d-flex justify-content-between align-items-center pb-2 border-bottom"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "fs-5 fw-semibold m-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.setup"
  }))), /*#__PURE__*/React.createElement(RubriqSetupProgress, {
    step: step
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column justify-content-between py-sm-3 pe-sm-4 rubriq-criteria-step-container"
  }, isOnboardingStep && /*#__PURE__*/React.createElement(RubriqSetupOnboardingStep, {
    methodsOnboarding: methodsOnboarding,
    handleSubmit: handleSubmit,
    submitting: submitting
  }), isConfirmationStep && /*#__PURE__*/React.createElement(RubriqSetupConfirmationStep, {
    startTemplate: startTemplate,
    session: session,
    previousStep: previousStep,
    submitting: submitting
  }), isTextLimitStep && /*#__PURE__*/React.createElement(RubriqSetupTextLimitStep, {
    methodsTextLimit: methodsTextLimit,
    handleSubmit: handleSubmit,
    useCharacters: useCharacters,
    submitting: submitting,
    session: session,
    previousStep: previousStep
  }), !isOnboardingStep && !isConfirmationStep && !isTextLimitStep && /*#__PURE__*/React.createElement(RubriqSetupGeneralStep, {
    methodsStep: methodsStep,
    handleSubmit: handleSubmit,
    stepConfig: stepConfig,
    submitting: submitting,
    session: session,
    previousStep: previousStep
  }))));
};
export default RubriqSetupStep;